import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import ObtenerProvincias from '../functions/ObtenerProvincias';
import ObtenerPais from '../functions/ObtenerPais';
import ProvinciaTabla from '../types/ProvinciaTabla';
import PaisSeleccionar from '../types/PaisSeleccionar';
import ProvinciaSeleccionar from '../types/ProvinciaSeleccionar';

interface SeleccionarProvinciaProps {
    paisInicial: number;
    provinciaInicial: number;
    onChange: (provincia: ProvinciaSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarProvincia: React.FC<SeleccionarProvinciaProps> = ({ paisInicial, provinciaInicial, onChange, onClear, eliminando }) => {

    const [pais, setPais] = useState<PaisSeleccionar[]>([]);
    const [provincias, setProvincias] = useState<ProvinciaSeleccionar[]>([]);
    const [provinciaSeleccionada, setProvinciaSeleccionada] = useState<ProvinciaSeleccionar | null>({id: 0, name: ''});

    const handleProvinciaChange = (event: React.SyntheticEvent, newValue: ProvinciaSeleccionar | null) => {
        if (newValue === null) {
            setProvinciaSeleccionada(null);
            if (onClear) {
                onClear();
            }
            return;
        }
        setProvinciaSeleccionada(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
    };

    const fetchPais = async () => {
        const elPais = await ObtenerPais(paisInicial);
        if (elPais.pais_ok === 'si') {
            setPais([{
                id: elPais.pais.id,
                iso_code: elPais.pais.codigo_iso,
                tel_code: elPais.pais.codigo_telefonico,
                name: elPais.pais.nombre
            }]);
        }
    };

    const fetchProvincias = async () => {
        
        const data = await ObtenerProvincias(paisInicial);
        
        const provinciasRecuperadas: ProvinciaSeleccionar[] = [];
        
    
        for (const provincia of data.provincias) {

            provinciasRecuperadas.push({
                id: provincia.id,
                name: provincia.provincia
            });
        }
 
        setProvincias(provinciasRecuperadas);        

        if (provinciaInicial > 0) {
            const provinciaInicio = data.provincias.find(
                (p: ProvinciaSeleccionar) => p.id === provinciaInicial
            );
            if (provinciaInicio) {
                const provinciaInicioOK: ProvinciaSeleccionar = {
                    id: provinciaInicio.id,
                    name: provinciaInicio.provincia
                };
                setProvinciaSeleccionada(provinciaInicioOK);
                onChange(provinciaInicioOK);
            }
        }
    };

    useEffect(() => {
        fetchPais()
        fetchProvincias();
    }, []);

    useEffect(() => {
        fetchPais();
        fetchProvincias();
    }, [paisInicial, provinciaInicial]);

    return (
        <div className="flex flex-col w-full">
            <Autocomplete<ProvinciaSeleccionar>
                options={provincias}
                getOptionLabel={(option: ProvinciaSeleccionar) => `${option.name}`}
                renderInput={(params) => <TextField {...params} label="Selecciona una provincia" />}
                value={provinciaSeleccionada}
                onChange={handleProvinciaChange}
                isOptionEqualToValue={(option: ProvinciaSeleccionar, value: ProvinciaSeleccionar) => option.id === value.id}
                renderOption={(props, option: ProvinciaSeleccionar) => (
                <li {...props}>
                    {option.name}
                </li>
                )}
                size="small"
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarProvincia;